import React from 'react';
import getCopyright from '../domain/getCopyright';
import Locale from '../domain/Locale';
import Conditions from './Conditions';
import PolicyCookies from './PolicyCookies';
import HowItWorks from './HowItWorks';
import CookiesDisclaimer from './CookiesDisclaimer';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  doAcceptCookies: t.maybe(t.Func)
})

export default class Footer extends React.Component {

  render() {
    const locale = this.props.locale;

    return (
      <div id='footer'>
        <div className="cols">
          <div className="large-25 medium-50 small-100">
            <div className="cell">{getCopyright()}</div>
          </div>
          <div className="large-25 medium-50 small-100">
            <div className="cell"><Conditions locale={locale}/></div>
          </div>
          <div className="large-25 medium-50 small-100">
            <div className="cell"><PolicyCookies locale={locale}/></div>
          </div>
          <div className="large-25 medium-50 small-100">
            <div className="cell"><HowItWorks locale={locale}/></div>
          </div>
        </div>
        <div className="cols">
          <CookiesDisclaimer locale={locale} doAcceptCookies={this.props.doAcceptCookies}/>
        </div>
      </div>
    );
  }
}





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Footer.js
 **/